<template>
  <dialog-custom
    :is-dialog-open="isDialogOpen"
    :dialog-title="dialogTitle"
    :close-dialog="closeDialog"
  >
    <v-form
      ref="formRef"
      class="multi-col-validation"
    >
      <v-row>
        <v-col :cols="$vuetify.breakpoint.lgAndUp ? 6 : 12">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="agendamentoMensagemDataLocale.nome"
                dense
                outlined
                label="Nome do Agendamento"
                placeholder="Nome do Agendamento"
                validate-on-blur
                :disabled="!podeEditarCampos"
                :rules="[validators.required, v => (!!v && v.length <= 100) || 'Máximo de 100 caracteres']"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="agendamentoMensagemDataLocale.descricao"
                dense
                outlined
                no-resize
                validate-on-blur
                label="Descrição do Agendamento"
                placeholder="Descrição Agendamento"
                :disabled="!podeEditarCampos"
                :rules="[v => !v || v.length <= 500 || 'Máximo de 500 caracteres']"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <agendamento-envio-mensagem-contatos
                :grupos-contatos-ids.sync="agendamentoMensagemDataLocale.gruposContatosIds"
                :readonly="possuiStatusAgendado"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <agendamento-envio-mensagem-canal-select
                :tipo-de-canal-selecionado-id.sync="tipoDeCanalSelecionadoId"
                :canal-selecionado-id.sync="agendamentoMensagemDataLocale.canalId"
                :handle-tipo-de-canal-selecionado-change="handleTipoDeCanalSelecionadoChange"
                :readonly="possuiStatusAgendado"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col
          :cols="$vuetify.breakpoint.lgAndUp ? 6 : 12"
          :class="$vuetify.breakpoint.lgAndUp ? 'mt-12 pl-6' : 'mt-0'"
        >
          <v-row
            v-if="canalEnvioEmailSelecionado"
            no-gutters
          >
            <v-col
              cols="12"
              class="pt-0"
            >
              <v-text-field
                v-model="agendamentoMensagemDataLocale.tituloEmail"
                dense
                outlined
                label="Título do E-mail"
                placeholder="Assunto que o cliente verá"
                hide-details="auto"
                class="mb-4"
                :disabled="!podeEditarCampos"
              />
            </v-col>
          </v-row>

          <v-row
            v-if="canalEnvioSmsSelecionado"
            no-gutters
          >
            <v-col cols="12">
              <v-text-field
                v-model="agendamentoMensagemDataLocale.tituloSMS"
                dense
                outlined
                label="Título SMS"
                placeholder="Título SMS"
                :disabled="!podeEditarCampos"
                :rules="[validators.required, v => (!!v && v.length < 200) || 'Máximo de 200 caracteres']"
              />
            </v-col>
          </v-row>

          <!-- Toggle Template / Livre -->
          <v-row
            v-if="canalEnvioEmailSelecionado"
            no-gutters
          >
            <v-col
              cols="12"
              class="pb-2"
            >
              <v-radio-group
                v-model="tipoDeEmail"
                row
                hide-details
                class="mt-0"
                :disabled="!podeEditarCampos"
              >
                <v-radio
                  label="Usar Template Pronto"
                  value="TEMPLATE"
                  color="primary"
                />
                <v-radio
                  label="Escrever Novo E-mail"
                  value="LIVRE"
                  color="primary"
                  class="ml-4"
                />
              </v-radio-group>
            </v-col>
          </v-row>

          <!-- Modo Livre: Editor Outlook -->
          <v-row
            v-if="canalEnvioEmailSelecionado && tipoDeEmail === 'LIVRE'"
            no-gutters
          >
            <v-col cols="12">
              <div
                class="v-label theme--dark mb-2"
                style="font-size: 12px;"
              >
                Conteúdo do E-mail
              </div>

              <editor-outlook
                :key="editorKey"
                v-model="agendamentoMensagemDataLocale.conteudoHtmlCustomizado"
              />

              <!-- Tags disponíveis -->
              <div class="mt-2 ml-1">
                <span style="font-size: 11px; color: grey;">
                  Tags disponíveis (clique para copiar):
                </span>
                <div class="d-flex flex-wrap mt-1">
                  <v-chip
                    v-for="tag in tagsDisponiveis"
                    :key="tag.label"
                    x-small
                    outlined
                    color="primary"
                    class="mr-1 mb-1"
                    style="cursor: pointer;"
                    @click="copiarTag(tag.valor)"
                  >
                    {{ tag.label }}
                  </v-chip>
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- Modo Template -->
          <v-row
            v-if="canalEnvioEmailSelecionado && tipoDeEmail === 'TEMPLATE'"
            no-gutters
          >
            <v-col cols="12">
              <agendamento-envio-mensagem-template-email
                :template-email-selecionado-id.sync="agendamentoMensagemDataLocale.templateEmailId"
              />
            </v-col>
          </v-row>

          <v-row v-if="canalEnvioWhatsAppSelecionado && agendamentoMensagemDataLocale.canalId">
            <v-col cols="12">
              <agendamento-envio-mensagem-template-whats-app
                :canal-id="agendamentoMensagemDataLocale.canalId"
                :template-whats-app-selecionado-id.sync="agendamentoMensagemDataLocale.templateWhatsAppId"
              />
            </v-col>
          </v-row>

          <v-row
            v-if="canalEnvioEmailSelecionado"
            class="mt-4"
          >
            <v-col cols="12">
              <agendamento-envio-mensagem-anexos
                :loading="isGetAgendamentoMensagemAnexosLoading"
                :anexos="agendamentoMensagemAnexos"
                @update:anexos="v => agendamentoMensagemEmailAnexos = v"
              />
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12">
              <agendamento-envio-mensagem-date-time
                :date-time-iso.sync="agendamentoMensagemDataLocale.dataHoraEnvio"
                :required="isDataEHoraObrigatorios"
                :readonly="!podeEditarCampos"
              />
            </v-col>
          </v-row>

          <v-row class="mt-6">
            <v-col
              cols="12"
              class="d-flex justify-center"
            >
              <v-btn
                color="error"
                outlined
                @click="resetFormAndCloseDialog"
              >
                Cancelar
              </v-btn>

              <v-btn
                v-if="permitirBotaoSalvarAgendamento"
                color="primary"
                class="ml-2"
                :loading="isSalvarAgendamentoLoading"
                @click="salvarAgendamento"
              >
                Salvar Rascunho
              </v-btn>

              <v-btn
                v-if="permitirBotaoConfirmarAgendamento"
                color="success"
                class="ml-2"
                :loading="isConfirmarAgendamentoLoading"
                @click="confirmarAgendamento"
              >
                Confirmar agendamento
              </v-btn>

              <v-btn
                v-if="possuiStatusAgendado && !modoEdicaoAgendado"
                color="primary"
                outlined
                class="ml-2"
                @click="modoEdicaoAgendado = true"
              >
                Editar
              </v-btn>

              <v-btn
                v-if="possuiStatusAgendado && modoEdicaoAgendado"
                color="primary"
                class="ml-2"
                :loading="isSalvarAgendamentoLoading"
                @click="salvarAgendado"
              >
                Salvar Alterações
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </dialog-custom>
</template>

<script>
import Vue from 'vue'
import { ref, computed, watch } from '@vue/composition-api'
import { required } from '@/@core/utils/validation'
import DialogCustom from '@/components/dialog/Dialog.vue'
import AgendamentoEnvioMensagemContatos from './AgendamentoEnvioMensagemContatos.vue'
import AgendamentoEnvioMensagemDateTime from './AgendamentoEnvioMensagemDateTime.vue'
import AgendamentoEnvioMensagemCanalSelect from './AgendamentoEnvioMensagemCanalSelect.vue'
import AgendamentoEnvioMensagemTemplateEmail from './AgendamentoEnvioMensagemTemplateEmail.vue'
import AgendamentoEnvioMensagemTemplateWhatsApp from './AgendamentoEnvioMensagemTemplateWhatsApp.vue'
import AgendamentoEnvioMensagemAnexos from './AgendamentoEnvioMensagemAnexos.vue'
import EditorOutlook from '@/components/email-editor/EditorOutlook.vue'

import AgendamentoEnvioMensagemModel from '@/models/entities/agendamento-envio-mensagem/AgendamentoEnvioMensagemModel'
import AgendamentoEnvioMensagemStatusEnum from '@/models/entities/agendamento-envio-mensagem/AgendamentoEnvioMensagemStatusEnum'
import TiposDeCanaisEnum from '@/models/entities/canal/TiposDeCanaisEnum'
import AgendamentoMensagensService from '@/services/modules/AgendamentoMensagensService'
import DocumentoService from '@/services/modules/DocumentoService'
import useDialog from '@/composables/useDialog'

function isHtmlEffectivelyEmpty(html) {
  if (!html) return true
  const cleaned = String(html)
    .replace(/<p><br><\/p>/g, '')
    .replace(/&nbsp;/g, '')
    .replace(/<br\s*\/?>/g, '')
    .replace(/<[^>]+>/g, '')
    .trim()
  return cleaned.length === 0
}

export default {
  components: {
    DialogCustom,
    AgendamentoEnvioMensagemContatos,
    AgendamentoEnvioMensagemDateTime,
    AgendamentoEnvioMensagemCanalSelect,
    AgendamentoEnvioMensagemTemplateEmail,
    AgendamentoEnvioMensagemTemplateWhatsApp,
    AgendamentoEnvioMensagemAnexos,
    EditorOutlook,
  },

  emits: ['update:isDialogOpen', 'update:agendamentoMensagemData'],

  props: {
    isDialogOpen: { type: Boolean, required: true },
    agendamentoMensagemData: { type: Object, default: null },
    gruposContatosIdsInicial: { type: Array, default: () => [] },
  },

  setup(props, { emit }) {
    const agendamentoMensagemDataLocale = ref(new AgendamentoEnvioMensagemModel())
    const isGetAgendamentoMensagemAnexosLoading = ref(false)
    const agendamentoMensagemAnexos = ref([])

    const tipoDeCanalSelecionadoId = ref(null)
    const canalEnvioSmsSelecionado = computed(() => tipoDeCanalSelecionadoId.value === TiposDeCanaisEnum.SMS)
    const canalEnvioEmailSelecionado = computed(() => tipoDeCanalSelecionadoId.value === TiposDeCanaisEnum.Email)
    const canalEnvioWhatsAppSelecionado = computed(() => tipoDeCanalSelecionadoId.value === TiposDeCanaisEnum.WhatsApp)

    const agendamentoMensagemEmailAnexos = ref([])
    const tipoDeEmail = ref('TEMPLATE')
    const editorKey = ref(0)

    const modoEdicaoAgendado = ref(false)

    const isSalvarAgendamentoLoading = ref(false)
    const isConfirmarAgendamentoLoading = ref(false)
    const isCopiarAgendamentoLoading = ref(false)
    const isLoading = computed(() => isSalvarAgendamentoLoading.value || isConfirmarAgendamentoLoading.value || isCopiarAgendamentoLoading.value)

    // ─── Tags disponíveis ─────────────────────────────────────────────────────

    const tagsDisponiveis = [
      { label: 'Nome',    valor: '{{Nome_Solicitante}}' },
      { label: 'E-mail',  valor: '{{Email_Solicitante}}' },
      { label: 'Celular', valor: '{{Celular_Solicitante}}' },
      { label: 'CPF',     valor: '{{Cpf_Solicitante}}' },
      { label: 'CNPJ',    valor: '{{Cnpj_Solicitante}}' },
      { label: 'Empresa', valor: '{{Empresa_Solicitante}}' },
    ]

    function copiarTag(valor) {
      navigator.clipboard.writeText(valor)
      Vue.$toast.success(`Tag "${valor}" copiada!`)
    }

    // ─── Assinatura automática ────────────────────────────────────────────────

    const aplicarAssinaturaAutomatica = () => {
      const html = agendamentoMensagemDataLocale.value.conteudoHtmlCustomizado
      if (isHtmlEffectivelyEmpty(html)) {
        agendamentoMensagemDataLocale.value.conteudoHtmlCustomizado = `<p><br></p><p>Atenciosamente,</p><p><br></p><p><strong>${Vue.$store.state.usuario.nome}</strong></p>`
      }
    }

    watch(tipoDeEmail, val => {
      if (!canalEnvioEmailSelecionado.value) return
      if (val === 'TEMPLATE') {
        agendamentoMensagemDataLocale.value.conteudoHtmlCustomizado = null
      } else {
        agendamentoMensagemDataLocale.value.templateEmailId = null
        editorKey.value++
        aplicarAssinaturaAutomatica()
      }
    })

    async function getAgendamentoMensagensAnexos() {
      if (isGetAgendamentoMensagemAnexosLoading.value) return
      if (!props.agendamentoMensagemData?.id) return

      try {
        isGetAgendamentoMensagemAnexosLoading.value = true
        agendamentoMensagemAnexos.value = await DocumentoService.getAgendamentoMensagensAnexos(props.agendamentoMensagemData.id)
      } finally {
        isGetAgendamentoMensagemAnexosLoading.value = false
      }
    }

    function handleTipoDeCanalSelecionadoChange(novoCanal) {
      if (tipoDeCanalSelecionadoId.value !== novoCanal) {
        agendamentoMensagemDataLocale.value.canalId = null
        agendamentoMensagemDataLocale.value.mensagem = null
        agendamentoMensagemDataLocale.value.templateEmailId = null
        agendamentoMensagemDataLocale.value.templateWhatsAppId = null
        agendamentoMensagemDataLocale.value.tituloEmail = null
        agendamentoMensagemDataLocale.value.tituloSMS = null
        agendamentoMensagemDataLocale.value.conteudoHtmlCustomizado = null
        tipoDeEmail.value = 'TEMPLATE'
        editorKey.value++
      }
    }

    watch(
      () => props.isDialogOpen,
      open => {
        if (open && !props.agendamentoMensagemData?.id && props.gruposContatosIdsInicial?.length) {
          agendamentoMensagemDataLocale.value.gruposContatosIds = [...props.gruposContatosIdsInicial]
        }
      },
    )

    watch(
      () => props.agendamentoMensagemData?.id,
      async id => {
        if (!id) return
        const v = props.agendamentoMensagemData
        agendamentoMensagemDataLocale.value = JSON.parse(JSON.stringify(v))
        tipoDeCanalSelecionadoId.value = v.canalTipoId
        modoEdicaoAgendado.value = false

        const hasHtml = !isHtmlEffectivelyEmpty(v.conteudoHtmlCustomizado)
        tipoDeEmail.value = hasHtml ? 'LIVRE' : 'TEMPLATE'
        editorKey.value++

        await getAgendamentoMensagensAnexos()
      },
      { immediate: true },
    )

    const { formRef, resetForm, validateForm, FORM_ERROR, closeDialog, emitRefetchData } = useDialog(emit, 'isDialogOpen')

    function resetFormAndCloseDialog() {
      resetForm()
      closeDialog()
      agendamentoMensagemAnexos.value = []
      agendamentoMensagemEmailAnexos.value = []
      agendamentoMensagemDataLocale.value.dataHoraEnvio = null
      tipoDeEmail.value = 'TEMPLATE'
      editorKey.value++
      modoEdicaoAgendado.value = false
    }

    function validarEmailModo() {
      if (!canalEnvioEmailSelecionado.value) return true
      if (tipoDeEmail.value === 'TEMPLATE') return !!agendamentoMensagemDataLocale.value.templateEmailId
      return !isHtmlEffectivelyEmpty(agendamentoMensagemDataLocale.value.conteudoHtmlCustomizado)
    }

    function getAgendamentoRequestBody() {
      const payload = JSON.parse(JSON.stringify(agendamentoMensagemDataLocale.value || {}))

      payload.anexos = (agendamentoMensagemEmailAnexos.value || []).map(it => ({
        nome: it.nome,
        dataUrl: it.dataUrl,
      }))

      if (canalEnvioEmailSelecionado.value) {
        if (tipoDeEmail.value === 'TEMPLATE') payload.conteudoHtmlCustomizado = null
        else payload.templateEmailId = null
      }

      return payload
    }

    const isNovoAgendamento = computed(() => !agendamentoMensagemDataLocale.value.statusId)
    const dialogTitle = computed(() => (isNovoAgendamento.value ? 'Criar agendamento' : 'Editar agendamento'))
    const possuiStatusRascunho = computed(() => agendamentoMensagemDataLocale.value.statusId === AgendamentoEnvioMensagemStatusEnum.Rascunho)
    const possuiStatusAgendado = computed(() => agendamentoMensagemDataLocale.value.statusId === AgendamentoEnvioMensagemStatusEnum.Agendado)
    const podeEditarCampos = computed(() => isNovoAgendamento.value || possuiStatusRascunho.value || modoEdicaoAgendado.value)
    const permitirBotaoSalvarAgendamento = computed(() => isNovoAgendamento.value || possuiStatusRascunho.value)
    const permitirBotaoConfirmarAgendamento = computed(() => isNovoAgendamento.value || possuiStatusRascunho.value)
    const permitirBotaoNovoAgendamento = computed(() => possuiStatusAgendado.value)
    const isDescricaoMsgObrigatoria = computed(() => isNovoAgendamento.value || possuiStatusRascunho.value)
    const isDataEHoraObrigatorios = computed(() => isNovoAgendamento.value || possuiStatusRascunho.value)

    async function salvarAgendamento() {
      if (isLoading.value) return
      if (!validateForm()) { Vue.$toast(FORM_ERROR); return }
      if (!validarEmailModo()) { Vue.$toast('Para e-mail, selecione um template ou escreva o conteúdo.'); return }

      try {
        isSalvarAgendamentoLoading.value = true
        if (isNovoAgendamento.value) {
          await AgendamentoMensagensService.criarAgendamentoMensagem(getAgendamentoRequestBody())
          resetFormAndCloseDialog()
        } else {
          await AgendamentoMensagensService.atualizarAgendamentoMensagem(agendamentoMensagemDataLocale.value.id, getAgendamentoRequestBody())
        }
        emitRefetchData()
      } finally {
        isSalvarAgendamentoLoading.value = false
      }
    }

    async function confirmarAgendamento() {
      if (isLoading.value) return
      if (!validateForm()) { Vue.$toast(FORM_ERROR); return }
      if (!validarEmailModo()) { Vue.$toast('Para e-mail, selecione um template ou escreva o conteúdo.'); return }

      if (isNovoAgendamento.value) agendamentoMensagemDataLocale.value.id = null

      try {
        isConfirmarAgendamentoLoading.value = true
        await AgendamentoMensagensService.confirmarAgendamentoMensagem(getAgendamentoRequestBody())
        emitRefetchData()
        resetFormAndCloseDialog()
      } finally {
        isConfirmarAgendamentoLoading.value = false
      }
    }

    async function salvarAgendado() {
      if (isLoading.value) return
      if (!validateForm()) { Vue.$toast(FORM_ERROR); return }
      if (!validarEmailModo()) { Vue.$toast('Para e-mail, selecione um template ou escreva o conteúdo.'); return }

      try {
        isSalvarAgendamentoLoading.value = true
        await AgendamentoMensagensService.atualizarAgendamentoMensagem(agendamentoMensagemDataLocale.value.id, getAgendamentoRequestBody())
        modoEdicaoAgendado.value = false
        emitRefetchData()
        Vue.$toast.success('Agendamento atualizado com sucesso!')
      } finally {
        isSalvarAgendamentoLoading.value = false
      }
    }

    async function copiarAgendamento() {
      if (isLoading.value) return
      if (!validateForm()) { Vue.$toast(FORM_ERROR); return }

      try {
        isCopiarAgendamentoLoading.value = true
        const { id } = await AgendamentoMensagensService.copiarAgendamentoMensagem(agendamentoMensagemDataLocale.value.id)
        agendamentoMensagemDataLocale.value = await AgendamentoMensagensService.getById(id)
        emit('update:agendamentoMensagemData', null)
        emitRefetchData()
      } finally {
        isCopiarAgendamentoLoading.value = false
      }
    }

    return {
      agendamentoMensagemDataLocale,
      isGetAgendamentoMensagemAnexosLoading,
      agendamentoMensagemAnexos,
      tipoDeEmail,
      editorKey,
      tipoDeCanalSelecionadoId,
      canalEnvioSmsSelecionado,
      canalEnvioEmailSelecionado,
      canalEnvioWhatsAppSelecionado,
      agendamentoMensagemEmailAnexos,
      isSalvarAgendamentoLoading,
      isConfirmarAgendamentoLoading,
      isCopiarAgendamentoLoading,
      handleTipoDeCanalSelecionadoChange,
      tagsDisponiveis,
      copiarTag,
      formRef,
      resetFormAndCloseDialog,
      closeDialog,
      dialogTitle,
      modoEdicaoAgendado,
      possuiStatusAgendado,
      podeEditarCampos,
      permitirBotaoSalvarAgendamento,
      permitirBotaoConfirmarAgendamento,
      permitirBotaoNovoAgendamento,
      isDescricaoMsgObrigatoria,
      isDataEHoraObrigatorios,
      salvarAgendamento,
      salvarAgendado,
      confirmarAgendamento,
      copiarAgendamento,
      validators: {
        required,
        descricaoMensagemValidator(v) {
          return canalEnvioSmsSelecionado.value
            ? (!!v && v.length <= 160) || 'Máximo de 160 caracteres'
            : (!!v && v.length <= 1000) || 'Máximo de 1000 caracteres'
        },
      },
    }
  },
}
</script>
